
function getMenuRoutes(menus) {
  const menuRoutes = []
  res.forEach(item => {
    let menu
    if(item.children && item.children.length>0){
       getMenuRoutes(item.children)
    }else{
       if(item.funcKey){
           menuRoutes.push({
             path: "/"+item.uuid,
             name: item.uuid,
             component(resolve) {
               require([`@/${item.menuURL}`], resolve)
             },
             title: item.menuName,
             icon: item.menuIcon,
             meta:{
               title:item.menuName,
               icon:item.menuIcon,
               funcKey:item.funcKey,
               funcName:item.funcName,
               roleFuncKey:item.roleFuncKey
             }
           });
       }
    }
  })
  return menuRoutes
}

const state = {
  menus: [],
  dynamicRoutes:[]
}
const mutations = {
  set_menus: (state, menus) => {
    state.menus = menus;
  },
  set_routes: (state, routes) =>{
    state.dynamicRoutes=routes;
  }
}
const actions = {
  getMenus: function({
    commit
  }, menus) {
    if (menus && menus.length>0) {
      commit('set_menus', menus)
      //router.addRoutes(userDynamicRoutes)
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js